import Api from '../config/api';
import { IAuditLogResponse } from '../models/Actions/AuditLog';

export interface IAxiosAuditLog {
  data: IAuditLogResponse;
}

export class ActionsAuditActions {
  static getAuditLog(filterString: string): Promise<IAxiosAuditLog> {
    return Api.get('/actions/audit-log?' + filterString);
  }
}
